import { Chapter, FadeUp } from "@/components/motion";
import Countdown24 from "@/components/Countdown24";

export default function CountdownSection() {
  return (
    <section className="relative py-32 lg:py-44 bg-abyss border-y border-silver/10 overflow-hidden" data-testid="section-24h">
      <img
        src="https://images.pexels.com/photos/36346056/pexels-photo-36346056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
        alt=""
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.05] pointer-events-none"
      />
      <div className="relative mx-auto max-w-[1500px] px-6 lg:px-12">
        <Chapter num="04" label="EL COMPROMISO" className="mb-12" />
        <FadeUp>
          <span className="font-mono text-[11px] tracking-[0.35em] text-steel block mb-6">
            DESDE QUE GESTIONAMOS TU INCIDENCIA
          </span>
        </FadeUp>
        <FadeUp delay={0.1}>
          <Countdown24 testid="countdown-24h" />
        </FadeUp>
        <FadeUp delay={0.2} className="mt-10 max-w-xl text-mist leading-relaxed">
          Una vez recibida y gestionada la incidencia, comienza la cuenta atrás: compromiso de disponer de
          un técnico especializado en tu comercio en un máximo de{" "}
          <span className="text-silver">24 horas hábiles</span>.
        </FadeUp>
      </div>
    </section>
  );
}
